import Team from '../Teams/Team';
import Game from './Game';
import Broadcasts from './Broadcasts';

class Games {
  constructor(app) {
    this.app = app;
    this.broadcasts = new Broadcasts();
  }

  async get(args) {
    const params = new URLSearchParams();

    if (args.boundary) {
      params.append('boundary', args.boundary);
    }

    if (args.cache) {
      params.append('cache', !! args.cache);
    }

    if (args.gotw) {
      params.append('gotw', !! args.gotw);
    }

    if (args.order) {
      params.append('order', args.order);
    }

    if (args.page) {
      params.append('page', args.page);
    }

    if (args.limit) {
      params.append('limit', args.limit);
    }

    if (args.before) {
      params.append('before', args.before);
    }

    if (args.after) {
      params.append('after', args.after);
    }

    if (args.season) {
      params.append('season', args.season);
    }

    if (args.state) {
      params.append('state', args.state);
    }

    if (args.lat) {
      params.append('lat', args.lat);
    }

    if (args.lon) {
      params.append('lon', args.lon);
    }

    if (args.levels) {
      for (let i = 0; i < args.levels.length; i++) {
        params.append('levels[]', args.levels[i]);
      }
    }

    if (args.leagues) {
      for (let i = 0; i < args.leagues.length; i++) {
        params.append('leagues[]', args.leagues[i]);
      }
    }

    if (args.conferences) {
      for (let i = 0; i < args.conferences.length; i++) {
        params.append('conferences[]', args.conferences[i]);
      }
    }

    if (args.divisions) {
      for (let i = 0; i < args.divisions.length; i++) {
        params.append('divisions[]', args.divisions[i]);
      }
    }

    if (args.range) {
      params.append('range', args.range);
    }

    if (args.local) {
      params.append('local', args.local);
    }

    if (args.postal) {
      params.append('postal', args.postal);
    }

    if (args.teams) {
      for (let i = 0; i < args.teams.length; i++) {
        params.append('teams[]', args.teams[i]);
      }
    }

    if (args.sports) {
      for (let i = 0; i < args.sports.length; i++) {
        params.append('sports[]', args.sports[i]);
      }
    }

    if (args.squads) {
      for (let i = 0; i < args.squads.length; i++) {
        params.append('squads[]', args.squads[i]);
      }
    }

    if (args.timezone) {
      params.append('timezone', args.timezone);
    }

    if (args.nonce) {
      params.append('nonce', args.nonce);
    }

    if(args.pro) {
      params.append('pro', args.pro)
    }

    if(args.favs) {
      params.append('favs', args.favs)
    }

    const response = await this.app.api.get('games', params);

    if (response.isSuccess()) {
      return {
        total: response.getTotal(),
        data: response.getData().map(item => {
          return new Game()
            .setId(item.id)
            .setTitle(item.title)
            .setTimestamp(item.timestamp)
            .setDate(item.date)
            .setTime(item.time)
            .setLocalDate(item.date_local)
            .setLocalTime(item.time_local)
            .setDayDiff(item.day_diff)
            .setCategory(item.category)
            .setGender(item.gender)
            .setLevel(item.level)
            .setState(item.state)
            .setStatus(item.status)
            .setLocation(item.location)
            .setHomeTeam(
              new Team()
                .setId(item.teams.home.id)
                .setWpid(item.teams.home.wpid)
                .setTitle(item.teams.home.title)
                .setShortTitle(item.teams.home.short_title)
                .setSubtitle(item.teams.home.subtitle)
                .setMascot(item.teams.home.mascot)
                .setGender(item.teams.home.gender)
                .setUrl(item.teams.home.url)
                .setLogo(item.teams.home.logo)
                .setLogoHTML(item.teams.home.logoHTML)
                .setScore(item.teams.home.score)
                .setStatus(item.teams.home.status)
                .setAddress(item.teams.home.address)
                .setOrganizationId(item.teams.home.organizationId)
            )
            .setAwayTeam(
              new Team()
                .setId(item.teams.away.id)
                .setWpid(item.teams.away.wpid)
                .setTitle(item.teams.away.title)
                .setShortTitle(item.teams.away.short_title)
                .setSubtitle(item.teams.away.subtitle)
                .setMascot(item.teams.away.mascot)
                .setGender(item.teams.away.gender)
                .setUrl(item.teams.away.url)
                .setLogo(item.teams.away.logo)
                .setLogoHTML(item.teams.away.logoHTML)
                .setScore(item.teams.away.score)
                .setStatus(item.teams.away.status)
                .setAddress(item.teams.away.address)
                .setOrganizationId(item.teams.away.organizationId)
            )
            .setSport(item.sport)
            .setSquad(item.teams.home.subtitle)
            .setUrl(item.url);
        }),
      };
    } else {
      console.error(response.getMessage());
      return {
        total: 0,
        data: [],
      };
    }
  }

  async getRounds(args) {
    try {
      const data = new FormData();

      data.append('action', 'games_season_get_rounds');

      if (args.season) {
        data.append('season', args.season);
      }

      const response = await fetch(window.bvm.ajax, {
        method: 'POST',
        body: data,
      });

      if (! response.ok) {
        throw new Error(`[${response.status}] ${response.statusText}`);
      }

      const result = await response.json();

      if (result.success) {
        return result.data.items;
      } else {
        throw result.data.error;
      }
    } catch (error) {
      console.error(error);
    }

    return [];
  }

  async getBroadcast(args) {
    return await this.broadcasts.get(args);
  }
}

export default Games;
